module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-thumb.3852dc68.jpg";